import styled from 'styled-components';

export const FaqPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 30px 16px 40px 16px;
  box-sizing: border-box;

  @media (max-width: 600px) {
    padding-top: 80px;
  }
`;

export const FaqContainer = styled.div`
  width: 100%;
  max-width: 980px;
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const FaqSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FaqSectionTitle = styled.h2`
  font-size: 1.4rem;
  font-weight: 900;
  letter-spacing: 0.06rem;
  margin: 10px 0 0 0;
  padding-bottom: 16px;
`;

export const AccordionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
`;

export const Accordion = styled.details`
  background: white;
  overflow: hidden;
  transition: box-shadow 0.2s ease;

  &[open] {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const AccordionSummary = styled.summary`
  cursor: pointer;
  list-style: none;
  padding: 14px 0;
  margin: 0;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  position: relative;

  &::-webkit-details-marker {
    display: none;
  }

  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #333;
    transition: transform 0.2s ease;
    margin-left: 12px;
    flex-shrink: 0;
  }

  details[open] > &::after {
    transform: rotate(180deg);
  }
`;

export const AccordionContent = styled.div`
  padding: 0 0 14px 0;
  color: #333;
  line-height: 1.55em;
`;
